import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es.array.reduce.js";
import { flatten } from 'flat';
import deepFreeze from 'deep-freeze-strict';
import { merge } from '../../utils';
import { defaultThemeStructure } from '../defaultThemeStructure';
import { makeSpacing } from './makeSpacing';
import { makeBreakpoints } from './makeBreakpoints';
import { makeTypography } from './makeTypography';
export var makeArmorSubTheme = function makeArmorSubTheme() {
  var declaration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = arguments.length > 1 ? arguments[1] : undefined;
  var immutable = !options || options && options.immutable !== false;
  var theme = merge(defaultThemeStructure, declaration);
  theme.spacing = makeSpacing(theme);
  theme.breakpoints = makeBreakpoints(theme.breakpoints);
  theme.typography = makeTypography(theme.typography);
  var referenceIndex = flatten({
    body: theme.body,
    shape: theme.shape,
    typography: theme.typography,
    color: theme.color,
    elevation: theme.elevation,
    transition: theme.transition
  });
  theme.referenceIndex = Object.keys(referenceIndex).reduce(function (result, key) {
    return _objectSpread(_defineProperty({}, "$".concat(key), referenceIndex[key]), result);
  }, {});
  theme.$initialized = true;
  return immutable ? _objectSpread(_objectSpread({}, deepFreeze(theme)), {}, {
    componentOverrides: {}
  }) : theme;
};